import { type FC } from 'react'

import {
  RECOMMENDATION_SERVICE_CATEGORY,
  RECOMMENDATION_WIDGET_CATEGORY_TOP,
  useGetRecommendationWidgetId,
} from '../../../recommendation'
import { StoryblokRecommendationGridRenderer } from '../StoryblokRecommendation/StoryblokRecommendationGridRenderer'

type StoryblokAkeneoCategoryCrossSellGridProps = {
  categoryCode: string
}

export const StoryblokAkeneoCategoryCrossSellGrid: FC<
  StoryblokAkeneoCategoryCrossSellGridProps
> = ({ categoryCode }) => {
  const widgetId = useGetRecommendationWidgetId(
    RECOMMENDATION_SERVICE_CATEGORY,
    RECOMMENDATION_WIDGET_CATEGORY_TOP,
  )

  if (!widgetId) {
    return null
  }

  return (
    <StoryblokRecommendationGridRenderer
      cid={categoryCode}
      serviceId={RECOMMENDATION_SERVICE_CATEGORY}
      widgetId={widgetId}
    />
  )
}
